import { FlaskConical, Flame, BarChart3 } from "lucide-react";
import { Reveal } from "../site/Reveal";

const FACTS = [
  ["3", "Product platforms"],
  ["12", "Specialised formulations"],
  ["2", "Manufacturing sites in India"],
];

const PILLARS = [
  { icon: FlaskConical, t: "Sensory science", d: "Aroma profiles tuned to how ruminants, fish and shrimp actually detect feed." },
  { icon: Flame, t: "Process-proof", d: "Heat-stable carriers and liquid grades built to survive conditioning, pelleting and extrusion." },
  { icon: BarChart3, t: "Measured outcomes", d: "Preference, intake, digestibility and colour — each range is designed around a number that matters." },
];

export const Eyebrow = ({ children, light = false }) => (
  <p className={`text-[13px] font-bold uppercase tracking-[0.2em] flex items-center gap-3 ${light ? "text-[var(--lime)]" : "text-[var(--leaf)]"}`}>
    <span className={`h-[3px] w-8 ${light ? "bg-[var(--lime)]" : "bg-[var(--leaf)]"}`} />{children}
  </p>
);

export const Intro = () => (
  <section data-testid="intro-section" className="bg-white">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-20 md:py-32 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <div className="lg:col-span-7">
        <Eyebrow>Who we are</Eyebrow>
        <Reveal as="h2" className="font-display text-3xl sm:text-4xl lg:text-[3.4rem] leading-[1.08] text-[var(--forest)] mt-6">
          Feed additives that animals choose — and nutritionists trust.
        </Reveal>
        <Reveal as="p" delay={0.1} className="mt-6 text-base md:text-lg text-[var(--muted)] leading-relaxed max-w-2xl">
          Gait Naurish Ltd. develops and manufactures palatability, aquaculture and poultry performance solutions under the Flair brand — natural and nature-identical — for feed manufacturers, integrators and farms.
        </Reveal>
        <div className="mt-10 grid grid-cols-3 border-t-[3px] border-[var(--forest)]">
          {FACTS.map(([v, l], k) => (
            <Reveal key={l} delay={k * 0.08} className="pt-5 pr-4">
              <p data-testid={`fact-${k}`} className="font-display text-4xl md:text-6xl text-[var(--moss)]">{v}</p>
              <p className="text-sm md:text-base text-[var(--muted)] mt-1">{l}</p>
            </Reveal>
          ))}
        </div>
      </div>
      <Reveal className="lg:col-span-5 relative">
        <div className="relative aspect-[4/5] overflow-hidden rounded-[10px]">
          <img src="/images/cow-hand.jpg" alt="Dairy cow being hand-fed" className="h-full w-full object-cover" />
        </div>
        <div className="absolute -bottom-6 left-4 right-4 sm:left-auto sm:-left-8 sm:right-auto sm:w-72 bg-white rounded-[10px] shadow-[0_24px_50px_-20px_rgba(0,40,26,0.45)] p-5 flex items-center gap-4">
          <img src="/images/flair-logo.png" alt="Flair — Natural & Nature Identical" className="h-16 w-auto" />
          <p className="text-sm text-[var(--muted)]">Natural &amp; nature-identical solutions</p>
        </div>
      </Reveal>
    </div>
    <div className="bg-[var(--paper)]">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-14 md:py-16 grid md:grid-cols-3 gap-8 md:gap-12">
        {PILLARS.map(({ icon: Icon, t, d }, k) => (
          <Reveal key={t} delay={k * 0.08} className="flex gap-5">
            <span className="shrink-0 grid place-items-center h-14 w-14 rounded-full bg-[var(--forest)] text-[var(--lime)]"><Icon size={24} /></span>
            <div>
              <h3 className="font-display text-xl text-[var(--forest)]">{t}</h3>
              <p className="text-[var(--muted)] mt-2 leading-relaxed">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
